import "../css/Button.css";

export default function Button({ login, onPress, title }) {
  return (
    <button className={`button-4 ${login ? "login" : ""}`} onClick={onPress}>
      <span className="p1 bold">{title}</span>
    </button>
  );
}
